"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealKosherFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealKosherFilled = function MealKosherFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.472 10.5l3.8-6.515c.772-1.323 2.684-1.323 3.456 0l3.8 6.515h7.601c1.544 0 2.506 1.675 1.728 3.008L31.07 20l3.787 6.492c.778 1.334-.184 3.008-1.728 3.008h-7.6l-3.802 6.516c-.771 1.323-2.683 1.323-3.455 0l-3.8-6.516H6.87c-1.543 0-2.505-1.674-1.727-3.008L8.93 20l-3.787-6.492c-.778-1.333.184-3.008 1.727-3.008h7.602zm3.473 0L20 6.977l2.055 3.523h-4.11zm-7.278 6.523L8.61 13.5h4.11l-2.054 3.523zM12.403 20l3.792-6.5h7.61l3.792 6.5-3.792 6.5h-7.61L12.403 20zm-1.736 2.977L8.61 26.5h4.11l-2.054-3.523zm7.278 6.523L20 33.023l2.055-3.523h-4.11zm9.333-3h4.11l-2.055-3.523-2.055 3.523zm2.055-9.477l2.055-3.523h-4.11l2.055 3.523z",
    fill: "#97BA1E"
  }));
};

exports.MealKosherFilled = MealKosherFilled;
var _default = MealKosherFilled;
exports.default = _default;